export default "/assets/images/mila-product-white.ed6b41c51b1ed852.webp";